import { render, staticRenderFns } from "./SetOrders.vue?vue&type=template&id=2663b3cb&lang=pug"
import script from "./SetOrders.vue?vue&type=script&lang=js"
export * from "./SetOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports